import {isDevEnv} from '../../utils/platform';
import {featuresIDs, featuresIDsRestartingMap} from './constants/map';

export const supportFeaturePopoverTesting: (featureID: string) => void = (featureID: string) => {
    if (!isDevEnv()) return;
    if (!featuresIDs[featureID]) return;
    if (typeof featuresIDsRestartingMap[featureID] === 'function')
        featuresIDsRestartingMap[featureID]();
};
